<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="w-full p-5">
          <div class="flex justify-end items-center p-2 md:px-5">
            <div
              class="flex rounded-lg border border-gray-200 overflow-hidden bg-white"
            >
              <button
                @click="setTab('list')"
                :class="[
                  'px-3 py-2 text-sm transition-colors',
                  tab === 'list'
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-500 hover:text-gray-700',
                ]"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
              <button
                @click="setTab('card')"
                :class="[
                  'px-3 py-2 text-sm transition-colors border-l border-gray-200',
                  tab === 'card'
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-500 hover:text-gray-700',
                ]"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- list -->

        <div v-if="tab === 'list'" class="px-5 lg:px-10 pb-4">
          <div
            class="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4"
          >
            <!-- Heading -->
            <div class="flex items-center gap-2">
              <h1 class="text-lg md:text-xl font-semibold text-slate-800">
                Assignments
              </h1>

              <span
                class="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-600 rounded-full"
              >
                {{ assignmentInfo?.count || 0 }}
              </span>
            </div>

            <!-- Search + Filter -->
            <div class="flex flex-col sm:flex-row gap-3 w-full xl:w-auto">
              <!-- Search -->
              <div class="relative flex-1 sm:min-w-[280px]">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>

                <input
                  type="text"
                  v-model="searching"
                  @input="getdetails(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                />

                <button
                  v-if="searching"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <!-- Sort -->
              <div class="w-full sm:w-[180px]">
                <select
                  v-model="selected_filter"
                  @change="getdetails(1)"
                  class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="">Sort By</option>
                  <option value="title">A → Z</option>
                  <option value="-title">Z → A</option>
                  <option value="created_at">Newest First</option>
                  <option value="-created_at">Oldest First</option>
                </select>
              </div>
            </div>
          </div>

          <div class="py-5 rounded flex gap-4 cursor-pointer">
            <button
              @click="submitted = 'assignment'"
              class="relative pb-1 font-medium transition-all duration-300"
              :class="
                submitted === 'assignment'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-700'
              "
            >
              Assignments
              <span
                v-if="submitted === 'assignment'"
                class="absolute left-0 bottom-0 w-full h-0.5 bg-blues rounded-full"
              ></span>
            </button>

            <button
              @click="submitted = 'submitted'"
              class="relative pb-1 font-medium transition-all duration-300"
              :class="
                submitted === 'submitted'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-700'
              "
            >
              Submitted
              <span
                v-if="submitted === 'submitted'"
                class="absolute left-0 bottom-0 w-full h-0.5 bg-blues rounded-full"
              ></span>
            </button>
          </div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>

          <div class="h-full" v-else-if="submitted === 'assignment'">
            <div v-if="assignmentInfo?.data?.length > 0" class="mt-5 space-y-4">
              <div
                class="w-full overflow-scroll rounded-lg border border-gray-200 shadow-sm"
              >
                <table class="min-w-full text-sm">
                  <thead class="bg-gray-100">
                    <tr>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        Type
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-left"
                      >
                        Title
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center text-nowrap"
                      >
                        Due date
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-left"
                      >
                        Description
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        File
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        Status
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        Action
                      </th>
                      <th
                        class="px-6 py-3 font-semibold border-b border-r-2 text-textblues text-center text-nowrap"
                      >
                        Remark / Grade
                      </th>
                      <th
                        class="px-6 py-3 border-b font-semibold border-r-2 text-textblues text-center"
                      >
                        Accept Feedback
                      </th>
                      <th
                        class="px-6 py-3 border-b font-semibold text-textblues text-center"
                      >
                        Feedback
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(assignment, index) in assignmentInfo.data"
                      :key="assignment.id"
                      @click="pushDetailPage(assignment.id)"
                      class="border-b pb-3 hover:bg-gray-50 cursor-pointer"
                    >
                      <td class="px-4 py-3 border-r font-semibold text-textblues">
                        <img
                          class="w-10 h-10 object-cover rounded-md mx-auto"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment "
                        />
                      </td>
                      <td class="px-6 py-3 border-r md:w-[250px]">
                        <div class="text-sm font-semibold text-gray-800">
                          <p
                            :class="{ 'line-clamp-2': expandedIndex !== index }"
                            class="text-gray-500 break-words"
                          >
                            {{ assignment.title }}
                          </p>

                          <button
                            v-if="
                              assignment.title && assignment.title.length > 100
                            "
                            @click.stop="toggleTitle(index)"
                            class="text-blue-500 text-xs font-medium mt-1"
                          >
                            {{
                              expandedIndex === index
                                ? "Read Less"
                                : "Read More"
                            }}
                          </button>
                        </div>
                      </td>
                      <td
                        class="px-4 py-3 border-r font-semibold text-textblues text-center"
                      >
                        <p class="text-xs text-gray-500">
                          {{ assignment.duedate }}
                        </p>
                      </td>
                      <!-- {{ assignment.visibleLengths }} -->
                      <td class="px-4 py-3 border-r md:w-[250px]">
                        <div class="text-xs text-gray-600">
                          <p
                            :class="{
                              'line-clamp-2':
                                expandedDescriptionIndex !== index,
                            }"
                            class="text-gray-500 break-words"
                          >
                            {{ assignment.description || "NA" }}
                          </p>

                          <button
                            v-if="
                              assignment.description &&
                              assignment.description.length > 100
                            "
                            @click.stop="toggleDescription(index)"
                            class="text-blue-500 text-xs font-medium mt-1"
                          >
                            {{
                              expandedDescriptionIndex === index
                                ? "Read Less"
                                : "Read More"
                            }}
                          </button>
                        </div>
                      </td>
                      <td
                        class="px-4 py-3 border-r font-semibold text-textblues text-center"
                      >
                        <a
                          :href="assignment.file"
                          @click.stop
                          target="_blank"
                          download
                          class="inline-flex items-center justify-center w-8 h-8 bg-gray-100 rounded-lg hover:bg-blue-100 transition-colors duration-200"
                        >
                          <svg
                            class="w-4 h-4 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                          </svg>
                        </a>
                      </td>

                      <td
                        class="px-4 py-3 border-r font-semibold text-textblues text-center"
                      >
                        <div class="flex justify-center">
                          <span
                            v-if="
                              assignment.student_assignment_data
                                ?.verify_status == 'submitted'
                            "
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-amber-50 text-amber-600 border border-amber-200"
                          >
                            Pending
                          </span>

                          <span
                            v-else-if="
                              assignment.student_assignment_data
                                ?.verify_status == 'accepted'
                            "
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-green-50 text-green-600 border border-green-200"
                          >
                            <svg
                              class="w-3.5 h-3.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Accepted
                          </span>

                          <span
                            v-else-if="
                              assignment.student_assignment_data
                                ?.verify_status == 'rejected'
                            "
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-red-50 text-red-500 border border-red-200"
                          >
                            <svg
                              class="w-3.5 h-3.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                            Rejected
                          </span>

                          <span
                            v-else
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-gray-50 text-gray-500 border border-gray-300"
                          >
                            N/A
                          </span>
                        </div>
                      </td>
                      <td
                        class="px-4 py-3 border-r font-semibold text-textblues text-center"
                        v-if="assignment"
                      >
                        <button
                          v-if="
                            !assignment.student_assignment_data ||
                            (assignment.student_assignment_data
                              ?.verify_status != 'accepted' &&
                              assignment.student_assignment_data
                                ?.verify_status != 'submitted')
                          "
                          @click.stop="
                            this.assignmentPopup = !this.assignmentPopup;
                            this.assignmentId = assignment.id;
                            this.assignmentTitle = assignment.title;
                          "
                          :disabled="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          :class="
                            assignmentId === assignment.id && assignmentPopup
                              ? 'bg-gray-200 text-black cursor-not-allowed'
                              : 'bg-blues hover:bg-hover cursor-pointer text-white'
                          "
                          class="text-xs font-medium rounded-lg px-4 py-1.5 transition-colors duration-150"
                        >
                          Submit
                        </button>
                        <button
                          v-else-if="
                            assignment.student_assignment_data != null && [
                              assignment.student_assignment_data
                                ?.verify_status == 'submitted' ||
                                assignment.student_assignment_data
                                  ?.verify_status == 'rejected',
                            ] &&
                            assignment.student_assignment_data?.verify_status !=
                              'accepted'
                          "
                          @click.stop="checkAssignment(assignment)"
                          :disabled="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          :class="
                            assignmentId === assignment.id && assignmentPopup
                              ? 'cursor-not-allowed bg-gray-100'
                              : 'cursor-pointer bg-gray-100 hover:bg-blue-100'
                          "
                          class="inline-flex items-center justify-center w-8 h-8 rounded-lg transition-colors duration-150"
                          title="Edit / Resubmit"
                        >
                          <svg
                            class="w-4 h-4 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            />
                          </svg>
                        </button>
                        <p v-else>-</p>
                      </td>
                      <td
                        class="px-4 py-3 font-semibold border-r text-textblues text-center"
                      >
                        {{ assignment.student_assignment_data?.remark || "-" }}
                      </td>
                     <td
  class="px-4 py-3 border-r text-center align-top min-w-[220px] max-w-[220px]"
>
  <div
    v-if="assignment.student_assignment_data?.verify_status === 'accepted'"
  >
    <p
      class="text-xs text-gray-700 line-clamp-1 overflow-hidden break-words leading-5"
    >
      {{ assignment.student_assignment_data?.feedback || "-" }}
    </p>

    <button
      v-if="assignment.student_assignment_data?.feedback"
      @click.stop="openFeedbackPopup(assignment.student_assignment_data.feedback)"
      class="mt-1 text-xs font-medium text-blue-600 hover:text-blue-800 underline"
    >
      View
    </button>
  </div>

  <span v-else>-</span>
</td>

                      <td
                        class="px-4 py-3 text-gray-500 text-center"
                        v-if="assignment.is_active == true"
                      >
                        <div
                          v-if="
                            assignment.student_assignment_data != null && [
                              assignment.student_assignment_data
                                ?.verify_status === 'accepted' ||
                                assignment.student_assignment_data
                                  ?.verify_status === 'rejected',
                            ]
                          "
                          class="flex justify-center"
                        >
                          <button
                            v-if="assignment.assignment_feedback.user_feedback"
                            @click.stop="openfeedback(assignment.id)"
                            class="flex items-center gap-1 px-2 py-1 text-blue-600 hover:underline"
                            title="View Feedback"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                            <span class="text-xs font-medium"
                              >View Feedback</span
                            >
                          </button>
                          <button
                            v-else
                            class="text-textblues hover:underline hover:text-blue-600 text-xs font-medium"
                            @click.stop="
                              this.feedbackPopup = !this.feedbackPopup;
                              this.assignmentId = assignment.id;
                            "
                          >
                            Give Feedback
                          </button>
                        </div>
                        <div v-else>-</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="getdetails"
              />
            </div>

            <div v-else class="">No Data Found</div>
          </div>
          <div class="h-full" v-else-if="submitted == 'submitted'">
            <div v-if="assignmentInfo?.data?.length > 0" class="mt-5 space-y-4">
              <div
                class="w-full overflow-scroll rounded-lg border border-gray-200 shadow-sm"
              >
                <table class="min-w-full text-sm">
                  <thead class="bg-gray-100">
                    <tr>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        Type
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-left"
                      >
                        Title
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center text-nowrap"
                      >
                        Due date
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-left"
                      >
                        Description
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        Attempt
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        File
                      </th>
                      <th
                        class="px-6 py-3 border-b border-r-2 font-semibold text-textblues text-center"
                      >
                        Status
                      </th>
                      <th
                        class="px-6 py-3 font-semibold border-b border-r-2 text-textblues text-center text-nowrap"
                      >
                        Remark / Grade
                      </th>
                      <th
                        class="px-6 py-3 font-semibold border-b text-textblues text-center text-nowrap"
                      >
                        Accepted Feedback
                      </th>
                    </tr>
                  </thead>

                  <tbody class="divide-y divide-gray-100">
                    <tr
                      v-for="(assignment, index) in assignmentInfo.data"
                      :key="assignment.id"
                      @click="pushDetailPage(assignment.id)"
                      class="hover:bg-gray-50 transition whitespace-nowrap cursor-pointer"
                    >
                      <td class="px-6 py-3 border-r">
                        <img
                          class="w-10 h-10 object-cover rounded-md mx-auto"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td>
                      <!-- <td class="px-4 py-3 md:w-[200px] tooltip">
                        <router-link
                          :to="{
                            name: 'AssignmentDetail',
                            params: { assignment_id: assignment.id },
                          }"
                        >
                          <p
                            class="text-sm font-semibold line-clamp-3 text-gray-800"
                          >
                            {{ assignment.title }}
                          </p>
                        </router-link>
                        <span class="tooltiptext text-xs p-2">
                          {{ assignment.title }}
                        </span>
                      </td> -->
                      <td class="px-6 py-3 border-r md:w-[250px]">
                        <div
                          class="text-sm font-semibold text-gray-800 whitespace-normal"
                        >
                          <p
                            :class="{
                              'line-clamp-2': submitexpandedIndex !== index,
                            }"
                            class="text-gray-500 break-words"
                          >
                            {{ assignment.title }}
                          </p>

                          <button
                            v-if="
                              assignment.title && assignment.title.length > 100
                            "
                            @click.stop="submittoggleTitle(index)"
                            class="text-blue-500 text-xs font-medium mt-1"
                          >
                            {{
                              submitexpandedIndex === index
                                ? "Read Less"
                                : "Read More"
                            }}
                          </button>
                        </div>
                      </td>
                      <td class="px-6 py-3 border-r text-center">
                        <p class="text-xs text-gray-500">
                          {{ assignment.duedate }}
                        </p>
                      </td>
                      <!-- {{ assignment.visibleLengths }} -->
                      <td class="px-6 py-3 border-r md:w-[250px]">
                        <div
                          class="text-xs text-gray-600 whitespace-normal break-words"
                        >
                          <p
                            :class="{
                              'line-clamp-2':
                                submitexpandedDescriptionIndex !== index,
                            }"
                            class="text-gray-500 break-words"
                          >
                            {{ assignment.description || "NA" }}
                          </p>

                          <button
                            v-if="
                              assignment.description &&
                              assignment.description.length > 100
                            "
                            @click.stop="submittoggleDescription(index)"
                            class="text-blue-500 text-xs font-medium mt-1"
                          >
                            {{
                              submitexpandedDescriptionIndex === index
                                ? "Read Less"
                                : "Read More"
                            }}
                          </button>
                        </div>
                      </td>
                      <td
                        class="px-6 py-3 border-r font-semibold text-textblues text-center"
                      >
                        {{ assignment.student_assignment_data?.count || 0 }}
                      </td>
                      <td
                        class="px-6 py-3 border-r font-semibold text-textblues text-center"
                      >
                        <a
                          :href="assignment.file"
                          @click.stop
                          target="_blank"
                          download
                          class="inline-flex items-center justify-center w-8 h-8 bg-gray-100 rounded-lg hover:bg-blue-100 transition-colors duration-200"
                        >
                          <svg
                            class="w-4 h-4 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                          </svg>
                        </a>
                      </td>

                      <td
                        class="px-6 py-3 border-r font-semibold text-textblues text-center"
                      >
                        <div class="flex justify-center">
                          <span
                            v-if="
                              assignment.student_assignment_data
                                ?.verify_status == 'submitted'
                            "
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-amber-50 text-amber-600 border border-amber-200"
                          >
                            Pending
                          </span>

                          <span
                            v-else-if="
                              assignment.student_assignment_data
                                ?.verify_status == 'accepted'
                            "
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-green-50 text-green-600 border border-green-200"
                          >
                            <svg
                              class="w-3.5 h-3.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Accepted
                          </span>

                          <span
                            v-else-if="
                              assignment.student_assignment_data
                                ?.verify_status == 'rejected'
                            "
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-red-50 text-red-500 border border-red-200"
                          >
                            <svg
                              class="w-3.5 h-3.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                            Rejected
                          </span>

                          <span
                            v-else
                            class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-full bg-gray-50 text-gray-500 border border-gray-300"
                          >
                            N/A
                          </span>
                        </div>
                      </td>
                      <td
                        class="px-6 py-3 font-semibold text-textblues border text-center"
                      >
                        {{ assignment.student_assignment_data?.remark || "-" }}
                      </td>
                    <td
  class="px-4 py-3 border-r text-center align-top min-w-[220px] max-w-[220px]"
>
  <div
    v-if="assignment.student_assignment_data?.verify_status === 'accepted'"
  >
    <p
      class="text-xs text-gray-700 line-clamp-2 overflow-hidden break-words leading-5"
    >
      {{ assignment.student_assignment_data?.feedback || "-" }}
    </p>

    <button
      v-if="assignment.student_assignment_data?.feedback"
      @click.stop="openFeedbackPopup(assignment.student_assignment_data.feedback)"
      class="mt-1 text-xs font-medium text-blue-600 hover:text-blue-800 underline"
    >
      View
    </button>
  </div>

  <span v-else>-</span>
</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="this.getdetails"
              />
            </div>

            <div v-else>No Data Found</div>
          </div>
          <!-- <div class="h-full" v-else-if="submitted == 'submitted'">
            <div
              class="grid grid-cols-1 gap-10 mt-5 overflow-y-auto"
              v-if="submitassignmentInfo?.data?.length > 0"
            >
              <div class="w-full overflow-scroll border-b">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                    >
                      <th class="px-6 py-3">Name</th>
                      <th class="px-6 py-3">Title</th>

                      <th class="px-6 py-3">Submit date</th>
                      <th class="px-6 py-3">Aproved</th>
                      <th class="px-6 py-3">Remark / Grade</th>
                      <th class="px-6 py-3">Download</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="assignment in submitassignmentInfo.data"
                      :key="assignment"
                      class="border-b pb-3"
                    >
                      <td class="px-6 py-3">
                        <img
                          class="w-20 h-16 object-cover rounded-md"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td>
                      <td class="px-6 py-3">
                        <router-link
                          :to="{
                            name: 'AssignmentDetail',
                            params: { assignment_id },
                          }"
                        >
                          <p
                            class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                          >
                            {{ assignment.title }}
                          </p>
                        </router-link>
                      </td>
                      <td class="px-6 py-3">
                        <p
                          class="text-xs text-gray-600 text-left truncate mb-0"
                        >
                          Submited Date :
                          {{ formatDate(assignment.created_at) }}
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <p
                          v-if="assignment.verify_status == 'submitted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Pending</a>
                        </p>

                        <p
                          v-else-if="assignment.verify_status == 'accepted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #4bd08b; color: #4bd08b"
                        >
                          <a style="color: #4bd08b">Accepted</a>
                        </p>

                        <p
                          v-else
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Rejected</a>
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        {{ assignment.remark || "-" }}
                      </td>
                      <td class="px-6 py-3">
                        <a :href="assignment.file" target="_blank" download
                          ><img
                            class="p-1 w-6 h-6 object-contain"
                            src="@/assets/new/download.png"
                            alt="Download"
                        /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>No data Found</div>
          </div> -->
        </div>

        <!-- card -->

        <div v-else-if="tab === 'card'" class="px-5 lg:px-10 pb-4">
          <div
            class="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4"
          >
            <!-- Heading -->
            <div class="flex items-center gap-2">
              <h1 class="text-lg md:text-xl font-semibold text-slate-800">
                Assignments
              </h1>

              <span
                class="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-600 rounded-full"
              >
                {{ assignmentInfo?.count || 0 }}
              </span>
            </div>

            <!-- Search + Filter -->
            <div class="flex flex-col sm:flex-row gap-3 w-full xl:w-auto">
              <!-- Search -->
              <div class="relative flex-1 sm:min-w-[280px]">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>

                <input
                  type="text"
                  v-model="searching"
                  @input="getdetails(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-xs text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                />

                <button
                  v-if="searching"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <!-- Sort -->
              <div class="w-full sm:w-[180px]">
                <select
                  v-model="selected_filter"
                  @change="getdetails(1)"
                  class="w-full px-4 py-2 rounded-xl text-xs border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                >
                  <option value="">Sort By</option>
                  <option value="title">A → Z</option>
                  <option value="-title">Z → A</option>
                  <option value="created_at">Newest First</option>
                  <option value="-created_at">Oldest First</option>
                </select>
              </div>
            </div>
          </div>

          <div class="py-5 rounded flex gap-4 cursor-pointer">
            <button
              @click="submitted = 'assignment'"
              class="relative pb-1 font-medium transition-all duration-300"
              :class="
                submitted === 'assignment'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-700'
              "
            >
              Assignments
              <span
                v-if="submitted === 'assignment'"
                class="absolute left-0 bottom-0 w-full h-0.5 bg-blues rounded-full"
              ></span>
            </button>

            <button
              @click="submitted = 'submitted'"
              class="relative pb-1 font-medium transition-all duration-300"
              :class="
                submitted === 'submitted'
                  ? 'text-blue-600'
                  : 'text-slate-500 hover:text-slate-700'
              "
            >
              Submitted
              <span
                v-if="submitted === 'submitted'"
                class="absolute left-0 bottom-0 w-full h-0.5 bg-blues rounded-full"
              ></span>
            </button>
          </div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>

          <div class="h-full" v-else-if="this.submitted == 'assignment'">
            <div
              class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 gap-6 mt-6"
              v-if="assignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in assignmentInfo.data"
                :key="assignment.id"
                @click="pushDetailPage(assignment.id)"
                class="group relative bg-white border border-gray-200 rounded-2xl p-5 flex flex-col justify-between gap-4 transition-all duration-300 hover:shadow-lg hover:border-blue-100 cursor-pointer"
              >
                <div class="space-y-4">
                  <div
                    class="relative overflow-hidden rounded-xl bg-gray-50 aspect-video flex items-center justify-center"
                  >
                    <img
                      class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      src="@/assets/new/assignment.png"
                      alt="Assignment Illustration"
                    />
                  </div>

                  <div class="space-y-2">
                    <h4
                      class="text-sm font-semibold text-gray-800 truncate"
                      :title="assignment.title"
                    >
                      {{ assignment.title }}
                    </h4>
                    <p
                      class="text-xs text-gray-500 text-left truncate mb-0"
                      :title="assignment.description"
                    >
                      <span class="font-medium text-gray-700"
                        >Description:</span
                      >
                      <span class="text-gray-400 ml-1">{{
                        assignment.description
                      }}</span>
                    </p>

                    <div
                      class="flex items-center gap-1.5 text-xs text-gray-500"
                    >
                      <svg
                        class="w-4 h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <p class="mb-0">
                        <span class="font-medium text-gray-700">Due:</span>
                        <span class="text-gray-400 ml-1">{{
                          assignment.duedate
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="space-y-3 pt-2 border-t border-gray-50">
                  <div class="flex items-center justify-between gap-3 w-full">
                    <a
                      :href="assignment.file"
                      download
                      target="_blank"
                      @click.stop
                      class="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 transition"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      Download
                    </a>

                    <div v-if="assignment" class="max-w-[120px]">
                      <button
                        v-if="
                          !assignment.student_assignment_data ||
                          (assignment.student_assignment_data?.verify_status !==
                            'accepted' &&
                            assignment.student_assignment_data
                              ?.verify_status !== 'submitted')
                        "
                        @click.stop="
                          assignmentPopup = !assignmentPopup;
                          assignmentId = assignment.id;
                          assignmentTitle = assignment.title;
                        "
                        :disabled="
                          assignment.student_assignment_data?.verify_status ===
                          'accepted'
                        "
                        :class="
                          assignmentId === assignment.id && assignmentPopup
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-blues hover:bg-hover text-white shadow-sm shadow-blue-100'
                        "
                        class="text-xs font-medium rounded-lg px-3 py-1.5 transition text-center"
                      >
                        Submit
                      </button>

                      <button
                        v-else-if="
                          assignment.student_assignment_data != null &&
                          (assignment.student_assignment_data?.verify_status ===
                            'submitted' ||
                            assignment.student_assignment_data
                              ?.verify_status === 'rejected') &&
                          assignment.student_assignment_data?.verify_status !==
                            'accepted'
                        "
                        @click.stop="checkAssignment(assignment)"
                        :disabled="
                          assignment.student_assignment_data?.verify_status ===
                          'accepted'
                        "
                        class="p-1.5 rounded-lg border border-gray-200 hover:bg-gray-50 transition mx-auto block"
                        title="Edit Submission"
                      >
                        <img
                          src="@/assets/edit.svg"
                          alt="Edit"
                          class="w-5 h-5 object-contain"
                        />
                      </button>

                      <span
                        v-else
                        class="inline-block text-center text-xs font-semibold text-green-700 bg-green-50 border border-green-200 px-3 py-1.5 rounded-lg"
                      >
                        Submitted
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="
                      assignment.is_active === true &&
                      assignment.student_assignment_data != null &&
                      (assignment.student_assignment_data?.verify_status ===
                        'accepted' ||
                        assignment.student_assignment_data?.verify_status ===
                          'rejected')
                    "
                    class="pt-1"
                  >
                    <button
                      v-if="assignment.assignment_feedback?.user_feedback"
                      @click.stop="openfeedback(assignment.id)"
                      class="flex items-center justify-center gap-1.5 w-full px-3 py-2 rounded-xl bg-blue-50 text-blue-600 hover:bg-blue-100 transition-all font-medium text-xs"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                      View Feedback
                    </button>

                    <button
                      v-else
                      class="w-full bg-gray-50 border border-gray-200 text-gray-700 font-medium px-3 py-2 rounded-xl text-center text-xs hover:bg-gray-100 transition"
                      @click.stop="
                        feedbackPopup = !feedbackPopup;
                        assignmentId = assignment.id;
                      "
                    >
                      Give Feedback
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>No Data Found</div>
          </div>

          <div class="h-full" v-else-if="submitted == 'submitted'">
            <div
              class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 gap-6 mt-6"
              v-if="assignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in assignmentInfo.data"
                :key="assignment.id"
                @click="pushDetailPage(assignment.id)"
                class="group relative bg-white border border-gray-200 rounded-2xl p-5 flex flex-col justify-between gap-4 transition-all duration-300 hover:shadow-lg hover:border-blue-100 cursor-pointer"
              >
                <div>
                  <div
                    class="relative flex justify-center items-center overflow-hidden rounded-xl bg-gray-50 aspect-video"
                  >
                    <img
                      class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      src="@/assets/new/assignment.png"
                      alt="Assignment Thumbnail"
                    />
                  </div>
                </div>

                <div class="flex flex-col gap-2.5 justify-center">
                  <h4
                    class="text-sm text-gray-800 font-semibold text-left truncate mb-0"
                    :title="assignment.title"
                  >
                    {{ assignment.title }}
                  </h4>

                  <p
                    class="text-xs text-gray-500 text-left truncate mb-0"
                    :title="assignment.description"
                  >
                    <span class="font-medium text-gray-700">Description:</span>
                    <span class="text-gray-400 ml-1">{{
                      assignment.description
                    }}</span>
                  </p>

                  <div class="flex items-center gap-1.5 text-xs text-gray-500">
                    <svg
                      class="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <p class="mb-0">
                      <span class="font-medium text-gray-700">Due:</span>
                      <span class="text-gray-400 ml-1">{{
                        assignment.duedate
                      }}</span>
                    </p>
                  </div>

                  <p class="text-xs text-gray-500 text-left truncate mb-0">
                    <span class="font-medium text-gray-700">Attempt:</span>
                    <span class="text-gray-400 ml-1">{{
                      assignment.student_assignment_data?.count || 0
                    }}</span>
                  </p>

                  <div class="pt-2 border-t border-gray-50 mt-1">
                    <a
                      :href="assignment.file"
                      download
                      target="_blank"
                      @click.stop
                      class="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 transition-colors duration-200"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      Download Document
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div v-else>No Data Found</div>
          </div>
        </div>
        <!-- assignment popup  -->
        <div
          v-if="this.assignmentPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-textblues">Submit Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="this.assignmentPopup = false"
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submitassignment"
                  @submit.prevent="scheduleAssignment"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2 hidden">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div>
                    <!-- <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div> -->
                  </div>
                  <div class="flex flex-col w-full gap-2 hidden">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full">
                    <label for="attachments" class="text-left"
                      >Attachments <span class="text-red-400">*</span></label
                    >
                    <input
                      id="files"
                      type="file"
                      class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="inputchange"
                      required
                      accept=".pdf,.txt,.doc,.docx,.xls"
                    />
                    <p
                      class="text-[10px] text-gray-400 font-medium tracking-tight mt-0.5"
                    >
                      Accepted formats: PDF, DOC, DOCX,XLS (Max size
                      recommended)
                    </p>
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- edit assignment  -->
        <div
          v-if="this.assignmentEditPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="w-[90%] lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-textblues">Update Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="this.assignmentEditPopup = false"
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submiteditassignment"
                  @submit.prevent="updateAssignment"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <!-- <div class="w-full flex flex-col gap-2">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        v-model="assignment_title"
                        class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div> -->
                    <!-- <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div> -->
                  </div>
                  <!-- <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      v-model="assignment_des"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div> -->
                  <div class="flex flex-col w-full">
                    <label for="attachments" class="text-left"
                      >Attachments</label
                    >
                    <input
                      id="files"
                      type="file"
                      class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="inputchange"
                      accept=".pdf,.txt,.doc,.docx,.xls"
                    />
                    <p
                      class="text-[10px] text-gray-400 font-medium tracking-tight mt-0.5"
                    >
                      Accepted formats: PDF, DOC, DOCX,XLS (Max size
                      recommended)
                    </p>
                  </div>
                  <div class="flex gap-5 w-full text-xs text-textblues">
                    <a
                      :href="this.assignment_file"
                      @click.stop
                      target="_blank"
                      download
                    >
                      {{ this.assignment_file }}
                    </a>
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- feed back create -->
        <div
          v-if="this.feedbackPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-textblues">Submit Feedback</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="
                  this.feedbackPopup = false;
                  this.selectedRating = '';
                "
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submitfeedback"
                  @submit.prevent="scheduleFeedback"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      required
                      rows="3"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <!-- Label -->
                    <label
                      for="rating"
                      class="text-left text-sm font-medium text-gray-700"
                    >
                      Rating <span class="text-red-400">*</span>
                    </label>

                    <!-- Star Rating Preview -->
                    <div id="rating" class="flex items-center gap-1">
                      <template v-for="i in 5" :key="i">
                        <svg
                          @click="setRating(i)"
                          :class="[
                            'w-6 h-6 cursor-pointer transition-colors duration-200',
                            i <= selectedRating
                              ? 'text-yellow-400'
                              : 'text-gray-300',
                          ]"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                          />
                        </svg>
                      </template>
                    </div>
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-hover cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- feed back get -->
        <!-- view feedback -->
        <div
          v-if="feedbackModalOpen"
          class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
        >
          <div
            class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative"
          >
            <!-- Modal Header -->
            <div
              class="flex items-center justify-between p-5 border-b border-gray-200"
            >
              <h2 class="text-xl font-semibold text-gray-800">
                Feedback Details
              </h2>
              <button
                @click="feedbackModalOpen = false"
                class="text-gray-500 hover:text-red-500 text-2xl"
              >
                &times;
              </button>
            </div>
            <div class="flex flex-col gap-2 p-5">
              <!-- Description -->
              <div class="">
                <label class="text-sm font-medium text-gray-900 block mb-1">
                  Description:
                </label>
                <p class="text-gray-700 text-xs whitespace-pre-wrap">
                  {{ feedbacklist.text || "No description provided." }}
                </p>
              </div>

              <!-- Star Rating -->
              <div class="mb-4">
                <label class="text-sm font-medium text-gray-900 block mb-1">
                  Rating:
                </label>
                <div class="flex items-center gap-1">
                  <template v-for="i in 5" :key="i">
                    <svg
                      :class="[
                        'w-6 h-6 transition',
                        i <= feedbacklist.rating
                          ? 'text-yellow-400'
                          : 'text-gray-300',
                      ]"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                      />
                    </svg>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="showFeedbackPopup"
          @click.self="showFeedbackPopup = false"
          class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
        >
          <div
            class="w-full max-w-lg bg-white rounded-2xl shadow-xl overflow-hidden"
          >
            <!-- Header -->
            <div class="flex items-center justify-between px-5 py-4 border-b">
              <h3 class="text-lg font-semibold text-gray-800">Feedback</h3>

              <button
                @click="showFeedbackPopup = false"
                class="text-gray-500 hover:text-red-500 text-xl"
              >
                ✕
              </button>
            </div>

            <!-- Body -->
            <div class="p-5 max-h-[60vh] overflow-y-auto">
              <p class="text-sm text-gray-700 whitespace-pre-wrap leading-7">
                {{ feedbackContent }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import SideBar from "@/components/Student/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";
// import confirmPopup from "@/components/confirmPopup.vue";
// import leftNavigationStudent from "@/views/studentDashboard/leftnav.vue";
// import VuePdfEmbed from "vue-pdf-embed";

export default {
  data() {
    return {
      assignmentInfo: "",
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: null,
      idpass: null,
      assignmentPopup: false,
      assignmentEditPopup: false,
      assignmentEditPopup: false,
      editvalues: null,
      assignmentId: null,
      submitassignmentInfo: null,
      submitted: "assignment",
      assignmentsNull: false,
      is_detailsPopup: false,
      assignmentDetails: null,
      is_preview: false,
      courseDetailInfo: "",
      loading: true,
      tab: "list",
      disable_submit: false,
      assignment_title: "",
      assignment_des: "",
      assignment_file: "",
      update_assignment: "",
      totalPages: 1,
      current_page: 1,
      feedbackPopup: false,
      selectedRating: 0,
      deatilfeedback: false,
      feedbacklist: [],
      feedbackModalOpen: false,
      selected_filter: "",
      searching: "",
      assignmentTitle: null,
      expandedIndex: null,
      expandedDescriptionIndex: null,
      submitexpandedIndex: null,
      submitexpandedDescriptionIndex: null,
        showFeedbackPopup: false,
    feedbackContent: "",
    };
  },

  props: ["course_id"],

  components: {
    SideBar,
    FlashMessage,
    Pagination,
    // confirmPopup,
    // leftNavigationStudent,
    // VuePdfEmbed,
  },

  created() {},

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    axios
      .get(
        `${process.env.VUE_APP_API}/coursesdata/${this.course_id}/?Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        this.courseDetailInfo = response.data;
      });
    setTimeout(() => {
      this.getdetails(1);
    }, 200);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
     openFeedbackPopup(feedback) {
    this.feedbackContent = feedback;
    this.showFeedbackPopup = true;
  },
    toggleTitle(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    toggleDescription(index) {
      this.expandedDescriptionIndex =
        this.expandedDescriptionIndex === index ? null : index;
    },
    submittoggleTitle(index) {
      this.submitexpandedIndex =
        this.submitexpandedIndex === index ? null : index;
    },
    submittoggleDescription(index) {
      this.submitexpandedDescriptionIndex =
        this.submitexpandedDescriptionIndex === index ? null : index;
    },
    handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    setRating(rating) {
      this.selectedRating = rating;
    },
    showMore(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths += 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths += 50;
      }
    },
    showLess(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths = 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths = 50;
      }
    },
    pushDetailPage(id) {
      this.$router.push({
        name: "AssignmentDetail",
        params: { assignment_id: id },
      });
    },
    setTab(view) {
      this.tab = view;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    detailsPopup(value) {
      this.is_detailsPopup = true;
      this.assignmentDetails = value;
    },
    clearSearch() {
      this.searching = "";
      this.getdetails(1);
    },
    async getdetails(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/Inst_Assignment/view/?course_id=${this.course_id}&Key=${this.userInfo.token_key}&page=${page}&publish=true&search=${this.searching}&ordering=${this.selected_filter}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.assignmentInfo = response.data.data;
            this.totalPages = response.data.total_page;
            this.current_page = response.data.current_page;
            this.loading = false;
            if (Object.keys(this.assignmentInfo) == "error") {
              console.log("Null");
              this.assignmentsNull = false;
            } else {
              this.assignmentsNull = true;
              this.assignmentInfo?.data?.forEach((element) => {
                element["display_date"] = new Date(
                  element.duedate,
                ).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
                element["visibleLengths"] = 50;
                element["visibleTitleLengths"] = 50;
              });
            }
          }
        });

      await axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment/view/?course_id=${this.course_id}&user=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.submitassignmentInfo = response.data;
          if (Object.keys(this.submitassignmentInfo) == "error") {
            console.log("Null");
          }
        });
    },
    checkAssignment(assignment) {
      this.assignment_title = assignment.student_assignment_data.title;
      this.assignment_des =
        assignment.student_assignment_data.student_description;
      this.assignmentEditPopup = !this.assignmentEditPopup;
      this.assignmentId = assignment.id;
      this.update_assignment = assignment.student_assignment_data.id;
      this.assignment_file = assignment.student_assignment_data.file;
    },
    // edit assignment
    async updateAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/student-assignment-student-update/${this.update_assignment}/?Key=${this.userInfo.token_key}`;

      let formData = new FormData();
      if (fileVal) {
        formData.append("file", fileVal);
      }
      formData.append("title", this.assignment_title);
      formData.append("student_description", this.assignment_des);

      // formData.append("submit_date", el.target.elements.duedate.value);
      formData.append("verify_status", "submitted");
      formData.append("user", this.userInfo.user.id);
      formData.append("assignment_id", this.assignmentId);
      axios
        .put(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submiteditassignment.reset();
              this.assignmentEditPopup = false;
              this.disable_submit = false;
              this.assignmentId = "";
              this.getdetails(this.current_page);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },
    // get assignment uploaded
    getAssignmentUploaded(id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment/new/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitassignment.reset();
              this.assignmentPopup = false;
              this.disable_submit = false;
              this.getdetails(1);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },
    // student Submit Functions
    async scheduleAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/student_assignment/new/?Key=${this.userInfo.token_key}`;

      let formData = new FormData();
      formData.append("file", fileVal);
      // el.target.elements.title.value
      formData.append("title", this.assignmentTitle);
      formData.append(
        "student_description",
        el.target.elements.description.value,
      );
      // formData.append("submit_date", el.target.elements.duedate.value);
      formData.append("verify_status", "submitted");
      formData.append("user", this.userInfo.user.id);
      formData.append("assignment_id", this.assignmentId);
      axios
        .post(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitassignment.reset();
              this.assignmentPopup = false;
              this.disable_submit = false;
              this.assignmentId = "";
              this.getdetails(this.current_page);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },

    async deleteAssignment(data) {
      this.popupwindow = false;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/assignment_deleted/${data}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.message == "Assignment deleted successfully") {
            this.messages = {
              text: "Assignment Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      await this.getdetails(this.current_page);
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },
    async scheduleFeedback() {
      this.disable_submit = true;
      let bodyVal = {
        assignment: this.assignmentId,
        text: document.getElementById("description").value,
        rating: this.selectedRating,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/assignment-feedback/create/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 201) {
            this.messages = {
              text: "Feedback Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitfeedback.reset();
              this.feedbackPopup = false;
              this.deatilfeedback = true;
              this.disable_submit = false;
              this.selectedRating = "";

              this.getdetails(this.current_page);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async openfeedback(id) {
      console.log("ASdsdasd", id);
      this.feedbackModalOpen = true;
      await axios
        .get(
          `${process.env.VUE_APP_API}/assignment-feedback/update/delete/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.feedbacklist = res.data.data[0];
            console.log("  this.feedbacklist", this.feedbacklist.text);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
